import { PayloadAction } from '../../../store.model';
import { filterRows } from '../function/filter-rows.function';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { ToggleFilterButton } from './toggle-filter-button.action';

export function toggleFilterButtonReducer(
    state: MainState,
    action: PayloadAction<
        ActionType.MI2_MAIN__TOGGLE_FILTER_BUTTON,
        ToggleFilterButton
    >,
): MainState {
    try {
        const item = action.payload.item;

        const nextCurrPerfItems = [...state.currentPerformanceClassFilterItems];
        const nextPrevPerfItems = [
            ...state.previousPerformanceClassFilterItems,
        ];
        const nextImprovementItems = [...state.improvementGroupFilterItems];

        const currPrefIndex = nextCurrPerfItems.indexOf(item);
        if (currPrefIndex !== -1) {
            nextCurrPerfItems[currPrefIndex] = {
                ...item,
                selected: !item.selected,
            };
        }

        const prevPerfIndex = nextPrevPerfItems.indexOf(item);
        if (prevPerfIndex !== -1) {
            nextPrevPerfItems[prevPerfIndex] = {
                ...item,
                selected: !item.selected,
            };
        }

        const improvementIndex = nextImprovementItems.indexOf(item);
        if (improvementIndex !== -1) {
            nextImprovementItems[improvementIndex] = {
                ...item,
                selected: !item.selected,
            };
        }

        const nextFilteredDirectReports = filterRows({
            rows: state.rows,
            sortOptions: state.sortOptions,
            currentPerformanceClassFilterItems: nextCurrPerfItems,
            previousPerformanceClassFilterItems: nextPrevPerfItems,
            improvementGroupFilterItems: nextImprovementItems,
        });

        return {
            ...state,
            filteredRows: nextFilteredDirectReports,
            currentPerformanceClassFilterItems: nextCurrPerfItems,
            previousPerformanceClassFilterItems: nextPrevPerfItems,
            improvementGroupFilterItems: nextImprovementItems,
        };
    } catch {
        return {
            ...state,
        };
    }
}
